import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import type { ReactNode } from 'react';

/**
 * Somebody's words *about* the lesson, never the lesson itself — GEN-74.
 *
 * Two marks, because either alone is ambiguous: a tag naming the author, and the tinted
 * panel every other agent utterance on this screen already uses. Built on `Alert` rather
 * than beside it — a second tinted surface in the same colour would leave the reviewer
 * two visual languages for one idea. `docs/proof/GEN-74/README.md` has the screenshots.
 */
export function Commentary({
  author,
  children,
}: {
  /** Who wrote this — "Reviewer", "Planner", the operator's own "You". */
  author: string;
  children: ReactNode;
}) {
  return (
    // `Alert` announces itself to a screen reader, which is right for a save that failed
    // and wrong for eleven standing reviewer opinions. `note` is the same look, read in
    // document order instead of interrupting.
    <Alert severity="info" icon={false} role="note">
      <Stack spacing={1}>
        <Chip
          size="small"
          variant="outlined"
          color="info"
          label={author}
          sx={TAG}
        />
        {children}
      </Stack>
    </Alert>
  );
}

/** Hoisted: one `Commentary` renders per finding and per chat turn. */
const TAG = { alignSelf: 'flex-start' } as const;
